import React, { useEffect, useState } from "react"
import { IMember } from "../../../types/team"
import styled from "styled-components"
import PortraitHover from "./PortraitHover"

const ListItem = styled.li`
  padding: 10px 0;
  page-break-inside: avoid;
  break-inside: avoid;
  cursor: pointer;

  &.intern {
    opacity: 0.5;
  }
`

const ListItemTitle = styled.div`
  font-size: var(--font-size-md);
  text-transform: lowercase;

  &.team-current {
    &:hover {
      color: var(--color-green);
    }
  }
  &.team-former {
    font-family: var(--font-secondary);
    color: var(--color-grey-1);
  }
`

const ListItemContent = styled.div`
  color: var(--color-grey-1);
`

const Roles = styled(ListItemContent)`
  font-size: var(--font-size-sm);
`
const Year = styled(ListItemContent)`
  font-size: var(--font-size-sm);
  color: inherit;

  & > div {
    display: inherit;

    &:hover {
      color: var(--color-green);
    }
  }
`

interface IProps {
  title: string
  member?: IMember
  teamByYear?: IMember[]
  onClick?: () => void
  className?: string
}

const ListItemTeam = ({
  title,
  member,
  teamByYear,
  onClick,
  className,
}: IProps): JSX.Element => {
  const isIntern = member?.roles?.find(item => item === "stagiaire")

  return (
    <ListItem onClick={onClick} className={isIntern ? "intern" : ""}>
      <ListItemTitle className={className}>{title}</ListItemTitle>
      {member && <Roles>{member.roles?.join(" ")}</Roles>}

      {teamByYear && (
        <Year>
          {teamByYear.map(({ name, firstName, portrait }, i) => {
            return (
              <PortraitHover
                key={i}
                firstName={firstName}
                name={name}
                portrait={portrait}
                teamByYearLength={teamByYear.length}
                index={i}
              />
            )
          })}
        </Year>
      )}
    </ListItem>
  )
}

export default ListItemTeam
